import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { filter } from 'lodash';
import moment from 'moment';
import React from 'react';

import { SalesAnalysisReportFieldEnum as Fields } from 'Common/FieldEnum';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { SALES_ANALYSIS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DropdownObjectCreator } from 'Common/ObjectHelper';
import { SiteComponent } from 'Common/SiteComponent';
import Statuses from 'Common/Constants/Statuses';
import { TitledCard } from 'Components/';
import {
  SelectField,
  Toggle,
  RangeDatePickerField,
} from 'Common/SemanticWrapper';

import * as Constants from '../constants/SalesAnalysisConstants';

let filteredStatuses = [];

filteredStatuses = filter(Statuses, function(x) {
  return x.key !== StatusEnum.Deleted && x.key !== StatusEnum.Withdrawn;
});

const allValue = { key: 'ALL', value: 'ALL', text: 'All' };

filteredStatuses.unshift(allValue);

const SalesAnalysisReportFormComponent = props => {
  let users = [];
  users = props.usersData
    ? DropdownObjectCreator(props.usersData, 'UserId', 'UserName')
    : [];
  if (users.length > 1) {
    users.unshift({
      value: 'ALL',
      text: 'ALL',
      key: 'valueALL',
    });
  }

  const marginBottomStyle = { marginBottom: '15px' };
  const minHeightStyle = { minHeight: '100px' };

  return (
    <TitledCard title={'Report Parameters'}>
      <Form>
        <Grid className={'SalesAnalysisGrid'}>
          <Grid.Row columns={16} style={marginBottomStyle}>
            <Grid.Column width={10} style={minHeightStyle}>
              <Field
                placeholder={'Choose Type Here...'}
                options={Constants.MealTypeOptions}
                disabled={props.loading}
                component={SelectField}
                name={Fields.MealTypes}
                label={'Meal Types'}
                selectNoneButton
                selectAllButton
                multiple
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={16} style={marginBottomStyle}>
            <Grid.Column width={6} style={minHeightStyle}>
              <SiteComponent
                onChange={props.onSiteChange}
                disabled={props.loading}
                isLicensed={true}
                checkIsLicensed={true}
                isActive={true}
                name={Fields.SiteId}
                isAllRequired={true}
                isPrimary={true}
                isForm={true}
                selectFirst
              />
            </Grid.Column>
            <Grid.Column width={4} style={minHeightStyle}>
              <Field
                placeholder={'Choose User Here...'}
                disabled={props.loading}
                component={SelectField}
                name={Fields.UserId}
                options={users}
                label={'User'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={16}>
            <Grid.Column width={8} style={minHeightStyle}>
              <RangeDatePickerField
                fromName={Fields.FromDate}
                toName={Fields.ToDate}
                fromLabel={'From Date'}
                toLabel={'To Date'}
                placeholder={'MM/DD/YYYY'}
                fromDisabled={props.allDatesSelected}
                toDisabled={props.allDatesSelected}
              ></RangeDatePickerField>
            </Grid.Column>
            <Grid.Column width={4} style={{ marginTop: '30px' }}>
              <Field
                name={Fields.AllDates}
                component={Toggle}
                label={'All Dates'}
              ></Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={16} style={marginBottomStyle}>
            <Grid.Column width={4} style={minHeightStyle}>
              <Field
                placeholder={'Choose Status Here...'}
                component={SelectField}
                name={Fields.Statuses}
                options={
                  props.selectedStatuses.includes(allValue.key)
                    ? [allValue]
                    : filteredStatuses
                }
                label={'Status'}
                multiple
                upward
              ></Field>
            </Grid.Column>
            <Grid.Column width={4} style={minHeightStyle}>
              <Field
                label={'Grade'}
                component={SelectField}
                options={props.gradesData}
                name={Fields.Grade}
                placeholder={'Choose Grade Here...'}
                disabled={
                  props.gradesData !== null && props.gradesData.length > 0
                    ? false
                    : true
                }
                upward
              ></Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </TitledCard>
  );
};

const validate = values => {
  const errors = {};

  if (values[Fields.MealTypes].length === 0) {
    errors[Fields.MealTypes] = 'You must select at least one Meal Type';
  }

  if (values[Fields.Statuses].length === 0) {
    errors[Fields.Statuses] = 'You must select at least one Status';
  }

  if (values[Fields.SiteId].length === 0) {
    errors[Fields.SiteId] = 'You must select a Site';
  }

  if (values[Fields.UserId].length === 0) {
    errors[Fields.UserId] = 'You must select a User';
  }

  if (values[Fields.Grade].length === 0) {
    errors[Fields.Grade] = 'You must select a Grade';
  }

  if (values[Fields.FromDate].length === 0 && !values[Fields.AllDates]) {
    errors[Fields.FromDate] = 'You must select a date';
  }

  if (values[Fields.ToDate].length === 0 && !values[Fields.AllDates]) {
    errors[Fields.ToDate] = 'You must select a date';
  }

  if (
    moment(values[Fields.ToDate]).isBefore(moment(values[Fields.FromDate])) &&
    !values[Fields.AllDates]
  ) {
    errors[Fields.ToDate] = 'To Date must be after From Date.';
  }

  const toYear = moment(values[Fields.ToDate]).year();
  const fromYear = moment(values[Fields.FromDate]).year();
  const toQuarter = moment(values[Fields.ToDate]).quarter();
  const fromQuarter = moment(values[Fields.FromDate]).quarter();

  if (toYear !== fromYear) {
    if (toQuarter > 2 || fromQuarter < 3) {
      errors[Fields.ToDate] =
        'To Date must be in same Fical Year as From Date.';
    }
  } else {
    if (Math.abs(toQuarter - fromQuarter) > 1) {
      errors[Fields.ToDate] =
        'To Date must be in same Fical Year as From Date.';
    }
  }

  return errors;
};

export const SalesAnalysisReportForm = reduxForm({
  form: SALES_ANALYSIS_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(SalesAnalysisReportFormComponent);



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/components/SalesAnalysisReportForm.js